<template>
<div id="ContainerDrug"> 
      <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
        {{$t('drug.Edit')}}
      </h4>
      <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
        {{$t('drug.Add')}}        
      </h4> 
           <b-row>
            <b-col lg="3" md="3" sm="12">
                 <MdEdit
                     v-model="Drug.drugCode"                    
                     v-bind:Label="$t('drug.DrugCode')"          
                     v-bind:isReadOnly="this.$attrs.editMode"
                     v-bind:isRequired="true"
                     v-bind:MaxLengthProp="15"
                     v-bind:isValid="isCodeValid"
                     v-bind:Tag="'DrugCode'"
                     v-on:blur="OnCodeBlur(Drug.drugCode)"
                     :InvalidFeedback="$t('drug.DrugRequired')"
                     :SearchFieldCode="'code'"
                     v-bind:Id="'input_drug'"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                  v-bind:Label="$t('drug.Drugname')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'drugname'" 
                  v-bind:Tag="'DrugName'" 
                  v-bind:MaxLengthProp="125"
                  v-bind:isValid="isDrugNameValid"  
                  v-model="Drug.drugname"
                  v-bind:isRequired="true"
                  v-bind:Id="'input_drug_name'"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                  v-bind:Label="$t('drug.ActIngre')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'activeingredients'"  
                  v-bind:Tag="'ActIngre'"
                  v-bind:MaxLengthProp="255"  
                  v-model="Drug.activeingred"
                  v-bind:isValid="isActIngreValid"  
                  v-bind:isRequired="true"
                  v-bind:Id="'input_actIngre'"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                  v-bind:Label="$t('Medication.Dosage')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'dosage'"  
                  v-bind:Tag="'Dosage'"
                  v-bind:MaxLengthProp="240"  
                  v-bind:isValid="isDosageValid"  
                  v-model="Drug.dosage"
                  v-bind:isRequired="true"
                  v-bind:Id="'input_dosage'"/>
            </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('Medication.Form')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'form'"  
                    v-bind:MaxLengthProp="255"
                    v-bind:isValid="isFormValid" 
                    v-bind:Tag="'Form'"  
                    v-model="Drug.form"
                    v-bind:isRequired="true"
                    v-bind:Id="'input_m_form'"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.RouteN')"
                    v-bind:Options="RouteNameList"
                    v-bind:Model="Drug.routeName"
                    v-bind:FieldDescription="'text'"
                    v-bind:Tag="'RouteN'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    :IsDisabled="isReadOnlyDrug"             
                    :Input="ChangeDropDownRouteName"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">         
                  <MdSelect
                    v-bind:Label="$tc('Shared.ActionsTxt')"
                    v-bind:Options="ActionList"
                    v-bind:Model="Drug.action"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Tag="'Action'"
                    v-bind:Multiple="false"
                    :IsDisabled="isReadOnlyDrug"               
                    :Input="ChangeDropDownAction"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdSelect
                    v-bind:Label="$t('Medication.When')"
                    v-bind:Options="WhenList"
                    v-bind:Model="Drug.whenSig"
                    v-bind:Tag="'When'"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"    
                    :IsDisabled="isReadOnlyDrug"          
                    :Input="ChangeDropDownWhen"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="3" md="3" sm="12">
                  <MdSelect
                      v-bind:Label="$t('Medication.Reason')"
                      v-bind:Options="ReasonList"
                      v-bind:Model="Drug.reason"
                      v-bind:FieldDescription="'text'"
                      v-bind:FieldCode="'value'"
                      v-bind:Tag="'Reason'"
                      v-bind:Multiple="false"    
                      :IsDisabled="isReadOnlyDrug"          
                      :Input="changeDropDownReason"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="'Rxnorm'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'rxnorm'"  
                    v-bind:MaxLengthProp="10"
                    v-bind:Tag="'RxNorm'"  
                    v-model="Drug.rxNorm"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_rxnorm'"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="'Snomed'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'snomed'"  
                    v-bind:Tag="'SNomed'"
                    v-bind:MaxLengthProp="15"  
                    v-model="Drug.snoMedCode"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_snomd'"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('drug.OtherCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'othercode'"  
                    v-bind:MaxLengthProp="25" 
                    v-bind:Tag="'OtherCode'" 
                    v-model="Drug.otherCode"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_ocode'"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('drug.DefaultDays')"
                    v-bind:TypeProp="'number'" 
                    v-bind:Name="'defaultdays'"  
                    v-bind:MaxLengthProp="10"  
                    v-bind:Tag="'DefaultDay'"
                    v-model.number="Drug.defaultDays"
                    v-bind:isRequired="false"
                    v-bind:Id="'input_dd'"/>
              </b-col>            
              <b-col lg="3" md="3" sm="12">         
                  <MdSelect
                    v-bind:Label="$t('drug.ProductType')"
                    v-bind:Options="ProductTypeSelectList"
                    v-bind:Model="Drug.iscontrolledsubstance"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:Tag="'ProductType'"
                    :IsDisabled="isReadOnlyDrug"               
                    :Input="ChangeDropDownProductType"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">         
                  <MdSelect
                    v-bind:Label="$t('drug.ConSub')"
                    v-bind:Options="SubstanceScheduleSelectList"
                    v-bind:Model="Drug.controlledSubstanceSchedule"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Tag="'ControllerSustanceSchedule'"
                    v-bind:Multiple="false"
                    :IsDisabled="isReadOnlyDrug"               
                    :Input="ChangeDropDownSubstanceSchedule"/>
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('drug.UnitPrice')"
                    v-bind:TypeProp="'number'" 
                    v-bind:Name="'unitprice'"  
                    v-bind:Tag="'UnitPrice'"
                    v-bind:MaxLengthProp="10"  
                    v-model.number="Drug.unitPrice"
                    v-bind:isReadOnly="isReadOnlyDrug"
                    v-bind:isRequired="false"/>
              </b-col>
            </b-row>

            <b-row> 

               <b-col lg="3" md="3" sm="12">         
                  <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="StatusSelectList"
                    v-bind:Model="Status"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Tag="'Status'"
                    v-bind:Multiple="false"
                    v-bind:AllowEmpty="false"
                    :IsDisabled="isReadOnlyDrug"               
                    :Input="ChangeDropDownStatus"/>
              </b-col>

              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('drug.NDCCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'NDC'"  
                    v-bind:MaxLengthProp="25"  
                    v-bind:Tag="'NDC'"
                    v-model.number="Drug.ndc"
                    v-bind:isReadOnly="isReadOnlyDrug"
                    v-bind:isRequired="false"/>
              </b-col>

              <b-col lg="3" md="3" sm="12">
                  <MdEdit 
                    v-bind:Label="$t('drug.GFCCode')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'GFC'"  
                    v-bind:Tag="'GFC'"
                    v-bind:MaxLengthProp="25"  
                    v-model.number="Drug.gfc"
                    v-bind:isReadOnly="isReadOnlyDrug"
                    v-bind:isRequired="false"/>
              </b-col>
              </b-row>

              <b-row>

              <b-col lg="auto" md="auto" sm="auto">
                  <MdCheckBox
                      v-bind:Label="$t('drug.IsLook')"
                      v-bind:Name="'checkbox-LookAlikeSoundAlike'"
                      v-bind:ClassProp="'AlignCheck'"
                      v-bind:CheckedValue="true"
                      v-bind:Tag="'IsLook'"
                      v-bind:UncheckedValue="false"
                      v-model="Drug.isLasa"     
                      v-bind:isReadOnly="isReadOnlyDrug"            
                    />                    
              </b-col>
              <b-col lg="auto" md="auto" sm="auto">
                    <MdCheckBox
                      v-bind:Label="$t('drug.IsHigh')"
                      v-bind:Name="'checkbox-HighAlert'"
                      v-bind:ClassProp="'AlignCheck'"
                      v-bind:CheckedValue="true"
                      v-bind:Tag="'IsHigh'"
                      v-bind:UncheckedValue="false"
                      v-model="Drug.isHighAlert"
                      v-bind:isReadOnly="isReadOnlyDrug"                 
                    />                    
              </b-col>            
              <b-col lg="auto" md="auto" sm="auto">
                    <MdCheckBox
                      v-bind:Label="$t('drug.ResChange')"
                      v-bind:Name="'checkbox-RestrictChange'"
                      v-bind:ClassProp="'AlignCheck'"
                      v-bind:CheckedValue="true"
                      v-bind:Tag="'RestrictChange'"
                      v-bind:UncheckedValue="false"
                    v-model="Drug.restrictChange"                 
                    />                    
              </b-col>
              <b-col lg="auto" md="auto" sm="auto">
                    <MdCheckBox
                      v-bind:Label="$t('drug.ByPassMedInbox')"
                      v-bind:Name="'checkbox-ByPassMedInbox'"
                      v-bind:ClassProp="'AlignCheck'"
                      v-bind:Tag="'ByPassMedInbox'"
                      v-bind:CheckedValue="true"
                      v-bind:UncheckedValue="false"
                    v-model="Drug.bypassMedInbox"                 
                    />                    
              </b-col>
              <b-col lg="3" md="3" sm="12">
                  <MdCheckBox
                    v-bind:Label="$t('drug.UseMetha')"
                    v-bind:Name="'checkbox-MethaSpense'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:Tag="'UseMetha'"
                    v-bind:UncheckedValue="false"
                    v-model="Drug.useMethaSpense"  
                    v-bind:isReadOnly="isReadOnlyDrug"               
                  />                    
              </b-col>
              <!--<b-col lg="auto" md="auto" sm="auto">             
                  <MdRadioGroup
                      v-bind:Label="$t('Shared.Status')"
                      v-model="Drug.statusselect"
                      v-bind:Options="StatusSelectList"
                      v-bind:Name="'Status'"                                   
                  />
              </b-col>-->
            </b-row>

      <MdTitle v-bind:Text="$t('drug.RequiredAsse')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"  v-bind:StyleProp="'margin: 0em 0 0.7em 0'"/>

    <b-row>
      <b-col md="12" lg="12" sm="12">              
            <MdCheckListBox2 
                v-model="Drug.assessmentList"
                v-bind:Options="assessmentList"
                v-bind:OnChangeProp="OnChangeProp"
                v-bind:columnCount="4"               
                v-bind:Tag="'Assessment'"
                :textField="'testDescription'"
                :valueField="'testCode'"
                :isReadOnly="isReadOnlyDrug"/>
      </b-col>
    </b-row>

    <b-row>
        <b-col md="12" lg="12" sm="12">
                <MdMemo
                    v-bind:VisibleLabel="true"
                    v-bind:Label="$t('PatientDocument.Comments')"
                    v-bind:Name="'DrugUsComment'"
                    v-bind:Rows="'6'"
                    v-bind:MaxRows="'6'" 
                    v-bind:Tag="'Cooments'"          
                    v-model="Drug.comments"
                    v-bind:isReadOnly="isReadOnlyDrug"
                />
        </b-col>
    </b-row> 
        <div class="space-actions"></div>
    <div class="page-actions">      
        <MdButton
               v-bind:Label="$t('drug.DrugList')"
               v-bind:Name="'btndruglist'"
               v-bind:ClassProp="'secondary mx-2 btn-login'"
               v-on:click="DiscardChanges"/>    
        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="(this.isReadOnlyDrug)?'primary mx-2':'primary btn-login mx-2'"
            v-on:click="SaveOrEdit"
            v-bind:isReadOnly="isReadOnlyDrug"
            v-bind:Name="'btn_save_drug'"/>
    </div>

</div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import DrugService from '@/services/drug.service.js'
import EnumService from '@/services/enum.service' 
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission'
import GlobalService from '@/services/global.service'
//import Utils from '@/common/utils'

let elemSaveBtn = '';
 export default {
//     beforeRouteEnter(to, from, next) {
//         next(async vm => {
//             const iPI = await vm.CanViewAllowed();
//             if(iPI) next()
//             else next('/accessdenied');
//         }) 
//   },

    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
                this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Admission.Admission'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                    next();
                } else {
                    await this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },
  
 name: 'DrugUS',
 mixins: [ShowMessage, DBFunctions, Permission/*,EventBus*/],
  data(){
    return{
        parameter:{
            SearchCriteria:'',
            PageNumber : 1,
            PageSize:0,         
        },
        pendingChanges:false,
    assessmentList: [],   
    Status: { value: 'A', text: this.$t('Shared.Active') },
     Drug:{
        drugCode:'',
        drugname:'',
        dosage:'',
        form:'',
        activeingred:'',
        routeName:'',
        action:'',
        whenSig:'',
        rxNorm:'',
        reason:'',
        snoMedCode:'',
        otherCode:'',
        defaultDays:null,
        restrictChange:false,
        status: "A",
        iscontrolledsubstance:'',
        controlledSubstanceSchedule:'',
        isLasa:false,
        isHighAlert:false,
        unitPrice:null,
        useMethaSpense:false,
        bypassMedInbox:false,
        assessment:'',
        comments:'',
        ndc:'',
        gfc:'',
        assessmentList:[]
     },
        isReadOnlyDrug:false,
        dDrug:'',
        //permission:[],
        //Menu : this.$store.state.leftMenu,
        isdrugValid:true,  

        isCodeValid:true, 
        isDrugNameValid:true,
        isFormValid:true,
        isActIngreValid:true,
        isDosageValid:true,

        CodeExist:false,      
        OptionsRightMenu:{
          visible:false,
          ItemsList:[],
          btnvisible:false,
          itemdisabled: false,
          PatientCode:'',
          Mode:this.edit_mode,
          favButtonAtion:false          
        },

        RouteNameList:[],// EnumService.RouteNameList,
        ActionList: [], // EnumService.ActionList,
        WhenList: [],//  EnumService.WhenList,
        ReasonList:[],

        StatusSelectList: EnumService.StatusOptions,
        ProductTypeSelectList: EnumService.ProductTypeSelectList,
        SubstanceScheduleSelectList: EnumService.SubstanceScheduleSelectList
    }
  },

  methods:{

    ChangeDropDownRouteName(value) {
        this.Drug.routeName = value ? value.value : ''; 
    },

    ChangeDropDownAction(value) {
        this.Drug.action = value ? value.value : ''; 
    },

    ChangeDropDownWhen(value) {
      this.Drug.whenSig = value ? value.value : ''; 
    },

    ChangeDropDownProductType(value) {
      this.Drug.iscontrolledsubstance = value ? value.value : ''; 
    },

    ChangeDropDownSubstanceSchedule(value) {
      this.Drug.controlledSubstanceSchedule = value ? value.value : ''; 
    },

    changeDropDownReason(value){   
        this.Drug.reason = value ? value.value : '';              
    },

    OnChangeProp(){
     
    },

    ChangeDropDownStatus(item){
      this.Status = item;
      this.Drug.status = item.value;
    },

    DiscardChanges(){
       this.checkExistFavorite('/app/druglist');
       this.$router.push({name: "DrugList"});
    },


    onCodeConditionOk(){

    },

        async getRouteName(){          
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.RouteNameList = response.data.map(element => {return {value: element.value, text: element.description}});
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                   
                });        
        },

        async getAction(){         
            var param = {
                CodeType:"ACTION",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ActionList = response.data.map(element => {return {value: element.value, text: element.description}});    
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

        async getReason(){           
            var param = {
                CodeType:"REASON",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ReasonList = response.data.map(element => {return {value: element.value, text: element.description}});
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

        async getWhen(){            
            var param = {
                CodeType:"WHEN",
                GroupCreation:"SIG"
            };     
            await GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.WhenList = response.data.map(element => {return {value: element.value, text: element.description}});       
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                  
                });        
        },

    async getAssessmentList() {
          await GlobalService.getAssessment()
              .then((response) => {
                  if(response.status == '200'){    
                      this.assessmentList = response.data;
                  }                             
              })
              .catch((error) => {
                  this.showResponseErrorMessage(error);
              });
      },

    getDrug(){
      if(this.$attrs.editMode){
      DrugService.Get(this.$route.params.id)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.Drug = response.data;  

            //  this.assessmentSelected = this.Drug.assessmentList;

              if(this.Drug.status === "A"){
                this.Status.value = "A";
                this.Status.text = this.$t('Shared.Active');
              }
              if(this.Drug.status === "I"){
                this.Status.value = "I";
                this.Status.text = this.$t('Shared.Inactive');
              }
            }                   
        })
        .catch((error) => {  
            this.showResponseErrorMessage(error);     
        }); 
    
      }
    },

    AddDrug(){
      if(!this.CodeExist){
      this.$emit('load', true);
      DrugService.Add(this.Drug)
                .then((response) => {
                    if(response.status == '200'){
                        this.Drug = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);
                        /*if(!this.OffRoute){
                           this.GotoAdmissionList();
                        }*/
                        this.$router.push({name: "DrugList"}).catch(()=>{});
                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })
                .catch((error) => {  
                     elemSaveBtn.removeAttribute("disabled");  
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
      }else{
         this.showMessage(this.$tc('Msg.Error'),this.$t('drug.DrugCodeExist'),"error");
      }
    },


    EditDrug(){
      this.$emit('load', true);
      DrugService.Update(this.$route.params.id,this.Drug)
                .then((response) => {
                    if(response.status == '200'){
                        this.Drug = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);                        
                        this.$router.push({name: "DrugList"}).catch(()=>{});                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })
                .catch((error) => { 
                     elemSaveBtn.removeAttribute("disabled");  
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
    },

    PrepareParams(){
      this.Drug.assessmentList = this.assessmentSelected;
    },

     DoAction(){    
        !this.$attrs.editMode ? this.AddDrug() : this.EditDrug(); 
      },

      SaveOrEdit(){ 
         if (this.validate_required()) {
            this.DoAction();
         } else {
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
         }
      },

    validate_required() {       
        this.isCodeValid = this.Drug.drugCode.length > 0 ? true : false;        
        this.isDrugNameValid = this.Drug.drugname.length > 0 ? true : false;  
        this.isFormValid = this.Drug.form.length > 0 ? true : false;  
        this.isActIngreValid = this.Drug.activeingred.length > 0 ? true : false;  
        this.isDosageValid = this.Drug.dosage.length > 0 ? true : false; 
        return this.isCodeValid && this.isDrugNameValid && this.isFormValid && this.isActIngreValid && this.isDosageValid;
      },

      OnCodeBlur(value){           
          if(!this.$attrs.editMode){           
            if (value.trim()!== '') {          
            var parameter = {
               "drugCode":value
            };
            DrugService.getDrugsByCode(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                       if(response.data.length > 0){
                          this.showMessage(this.$tc('Msg.Error'),this.$t('drug.DrugCodeExist'),"error");
                          this.CodeExist = true;
                       }else{
                           this.CodeExist = false;
                       } 
                    }                   
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);                     
                });  
            }
               }
    
       },
       checkUserAction() {
        if (elemSaveBtn.disabled) {
          elemSaveBtn.removeAttribute('disabled');
        }
      },

           async runAll() {
            await Promise.allSettled([
                this.getAssessmentList(), 
                this.getReason(), 
                this.getRouteName(), 
                this.getAction(), 
                this.getWhen()
            ]);
        },

        beforeWindowUnload(e) {
          if (this.pendingChanges) {
            e.preventDefault()
            e.returnValue = ''	
          }
		}
  },

    created(){
        EventBus.$on("onChanged", function (e) {          
            this.pendingChanges = e.Changed;      
            this.checkUserAction();
        }.bind(this));       
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

  async mounted(){
      await this.runAll();
      this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

     
      this.getDrug();
      setTimeout( function() {
         elemSaveBtn = document.getElementById('btn_save_drug');
         elemSaveBtn.setAttribute('disabled','');
      }, 50, this );        
  },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    },
   
};
</script>
